import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { msMessageUrlServer } from 'src/app/global_constants';

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  token:any;
  baseUrl = msMessageUrlServer.concat("/message/v1/message");
  sendMessageSubject : Subject<any>;
  getMessagesSubject : Subject<any>;
  getLastMessagesSubject : Subject<any>;

  constructor(
    private httpClient: HttpClient
  ) { 
    this.sendMessageSubject = new Subject();
    this.getMessagesSubject = new Subject();
    this.getLastMessagesSubject = new Subject();


    this.token = sessionStorage.getItem("msToken") || localStorage.getItem("msToken");
  }

  sendMessage(reqBody : any) {
    this.sendMessageSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token );
    this.httpClient.post(this.baseUrl, reqBody, {headers: header}).subscribe((response: any) => {
        this.sendMessageSubject.next(response);
        this.sendMessageSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }

  getMessages(sentTo : any) {
    this.getMessagesSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token );
    this.httpClient.get(this.baseUrl+'s/'+sentTo, {headers: header}).subscribe((response: any) => {
        this.getMessagesSubject.next(response);
        this.getMessagesSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }

  getLastMessage(member: string): Observable<any> {
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    const url = `${this.baseUrl}/lastActivity/${member}`;
    return this.httpClient.get<any>(url,{headers: header});
  }

  getLastMessages() {
    this.getLastMessagesSubject = new Subject();
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token );
    this.httpClient.get(this.baseUrl+'/lastMessages', {headers: header}).subscribe((response: any) => {
        this.getLastMessagesSubject.next(response);
        this.getLastMessagesSubject.complete();
    },
      error => {
        console.error('There was an error!', error);
      }
    );
  }
}
